const theme = {
  colors: {
    primary: "#000000",
    primary70: "rgba(0, 0, 0, 0.72)",
    background: "#ffffff",
    buttonPrimary: "#FCCD3C",
    buttonSecondary: "#20C997",
    modalBackground: "#A385FF",
    gray: "#474747",
    link: "#470BFF",
    error: "#FF7272",
    navTabBorder: "#9B9B9B",
    accent: "#9B9B9B",
    inactiveTaskName: "#5B5B5B",
    cards: {
      fills: {
        unpicked: "#9B9B9B",
        picked: "#20C997",
        active: "#FCCD3C",
        inactive: "#FFFFFF",
        spectator: "#F8F9FA",
        summaryBarBg: "#E2E2E2",
        summaryBar: "#9B9B9B",
      },
      borders: {
        primary: "#000000",
        secondary: "#9B9B9B",
        summary: "#20C997",
        red: "#FF7272",
        yellow: "#FCCD3C",
      },
    },
    toasts: {
      success: {
        border: "#20C997",
        background: "#FBFEFD",
      },
      warning: {
        border: "#FCCD3C",
        background: "#FFFEFA",
      },
      error: {
        border: "#FF7272",
        background: "#FFFAFA",
      },
      close: "#9B9B9B",
      title: "#000000",
      text: "#333333",
    },
    agreement: {
      progressBg: "#C4C4C4",
      progressFill: "#20C997",
    },
    timer: {
      start: "#20C997",
      mid: "#FCCD3C",
      end: "#FF7272",
    },
  },
  border: {
    thinner: "1px",
    thin: "2px",
    thick: "4px",
  },
  borderRadius: {
    s: "4px",
    m: "8px",
    l: "16px",
  },
  fonts: {
    sizes: {
      xxxxs: "10px",
      xxxs: "14px",
      xxs: "16px",
      base: "18px",
      xs: "20px",
      s: "24px",
      m: "28px",
      l: "32px",
      xl: "64px",
    },
    weights: {
      thin: 300,
      normal: 300,
      medium: 400,
      bold: 400,
      bolder: 500,
      black: 700,
    },
    lineHeights: {
      xxxs: "20px",
      xxs: "24px",
      xs: "32px",
      s: "40px",
      m: "48px",
      l: "56px",
      xl: "64px",
    },
    family: "sofia-pro",
  },
  mq: {
    md: "(min-width: 1024px)",
    sm: "(max-width: 1024px)",
  },
};

export default theme;

export type ThemeType = typeof theme;
